import { render } from "./ModalRemoveAssignmentForUsers.vue?vue&type=template&id=29c15f8b"
import script from "./ModalRemoveAssignmentForUsers.vue?vue&type=script&lang=js"
export * from "./ModalRemoveAssignmentForUsers.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ModalRemoveAssignmentForUsers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__